import React from 'react';

import formatNumber from 'utils/formatNumber';

if (process.env.NODE_ENV !== 'test') {
  require('./CurrencyConverter.scss');
}

const CurrencyConverter = props => {
  const {
    tradeType,
    quickTrade,
    value,
    currency,
    currencyExchangeRate,
  } = props;

  const rates =
    tradeType === 'BUY'
      ? currencyExchangeRate && currencyExchangeRate.bid
      : currencyExchangeRate && currencyExchangeRate.ask;

  const floatValue =
    value && parseFloat(value.replace(/\s+/g, '').replace(',', '.'));

  const conversion =
    value &&
    `${value} ${currency} =
    ${formatNumber(floatValue * rates, 2)} NOK`;

  return (
    <div className={`CurrencyConverter ${quickTrade ? 'absolute' : ''}`}>
      <div>{value && `${conversion} `} </div>
    </div>
  );
};

export default CurrencyConverter;
